"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HTTPMethod;
(function (HTTPMethod) {
    HTTPMethod["DELETE"] = "DELETE";
    HTTPMethod["GET"] = "GET";
    HTTPMethod["HEAD"] = "HEAD";
    HTTPMethod["OPTIONS"] = "OPTIONS";
    HTTPMethod["PATCH"] = "PATCH";
    HTTPMethod["POST"] = "POST";
    HTTPMethod["PUT"] = "PUT";
})(HTTPMethod = exports.HTTPMethod || (exports.HTTPMethod = {}));
//# sourceMappingURL=types.js.map